import React, { Component } from 'react';

export class Contact extends Component {
  static displayName = Contact.name;

  render () {
    return (
      <div>
        <h2>Contact</h2>
            Ryan Couch<br/>
            <a href="https://maps.google.com/?q=6516+West+Pleasant+Way+Rogers,+AR+72758&amp;entry=gmail&amp;source=g">6516 W Pleasant Way</a><br/>
            Rogers, AR 72758<br/>
            <br/>
            <a href="tel:(479)502-0456">(479) 502.0456</a><br/>
            <a href="mailto:RCouch00@gmail.com">RCouch00@gmail.com</a><br/>
            <br/>
      </div>
    );
  }
}

{/* 
<a href="https://about.me/RyanCouch">about.me/RyanCouch</a><br/>
*/}
